import React from "react";
import { useState } from "react";
import DoubleRangeSlider from "../../../components/DoubleRangeSlider/DoubleRangeSlider";

const RangeContainer = ({ rangeValue }) => {
    const [range, setRange] = useState({ min: rangeValue.Min, max: rangeValue.Max });
    return (
        <div>
            <DoubleRangeSlider
                min={rangeValue.Min}
                max={rangeValue.Max}
                minValue={range.min}
                maxValue={range.max}
                onChange={(newRange) => setRange(newRange)}
            />
        </div>
    )


}
export default RangeContainer